import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import ExternalConnectionsForm from '../containers/ExternalConnectionsForm'

const ExternalPage = ({ user, updateUser, ffpsUsername, isAffililatedForm, isFfpsAffiliated}) => {
  return <LgySection header='External Account Connections' className='user-external'>
    {user.id && <ExternalConnectionsForm
      form={'userExternalConnectionsForm' + user.id}
      onSubmit={updateUser}
      user={user}
      isAffililatedForm={isAffililatedForm}
      initialValues={{ id: user.id, vaEauthSecId: user.vaEauthSecId, apiVaGovUserId: user.apiVaGovUserId, ffpsUsername: ffpsUsername, isFfpsAffiliated: isFfpsAffiliated }} />}
  </LgySection>
}

const selector = formValueSelector('fetchFfpsUserDetails')

const mapStateToProps = (state, ownProps) => ({
  ffpsUsername: selector( state, 'ffpsUsername' ),
  isAffililatedForm: selector(state, 'isAffililated'),
  isFfpsAffiliated: state.ffpsUserDetail.ffpsAffiliated

})

export default connect(mapStateToProps)(ExternalPage)